import React from 'react';

import S from './Headline.module.css';

const Headline = ({ isLocked }) => (
  <div className={S.root}>
    <div className={S.iconCeluar}></div>
    <div className={S.iconWifi}></div>
    <div className={S.iconBattery}></div>
    <div className={S.time} data-is-locked={isLocked.toString()}></div>
  </div>
);

export default Headline;
